export default {"src":"/_next/static/media/menu_white.c0f300a1.svg","height":385,"width":385};